import { GameStates } from "onearm";
import { SubGameState } from "./game/states/SubGameState";

export class AutoplaySettingsState extends SubGameState {
    autoplayOptions = {
        quickSpin: this.data.spinType === "quick",
        gamesLimit: 10,
        turboSpin: this.data.spinType === "turbo",
        skipScreen: false,
    };

    async enter() {

        this.autoplayOptions.quickSpin = this.data.spinType === "quick";
        this.autoplayOptions.turboSpin = this.data.spinType === "turbo";

        this.popup = this.scenes.add('AutoPlaySettingsScene', this.autoplayOptions);
        this.scenes.show("AutoPlaySettingsScene");
        this.addSignalHandler(this.popup.onPressClose, this.handleClose);
        this.addSignalHandler(this.popup.onChangeAutoplayGames, this.handleToggleAutoplayGames);
        this.addSignalHandler(this.popup.onChangeQuickSpin, this.handleToggleQuickSpin);
        this.addSignalHandler(this.popup.onChangeTurboSpin, this.handleToggleTurboSpin);
        this.addSignalHandler(this.popup.onChangeSkipScreen, this.handleToggleSkipScreen);
        this.addSignalHandler(this.popup.onPressStart, this.handleStartAutoplay.bind(this));

        this.data.on("spinType", this.handleChangeSpinType.bind(this));
    }

    handleClose() {
        this.owner.goTo(GameStates.IDLE);
    }

    exit() {
        super.exit();
        this.scenes.remove("AutoPlaySettingsScene");
    }

    handleToggleQuickSpin(value) {
        this.autoplayOptions.quickSpin = value;
        this.data.spinType = value ? "quick" : "normal";
    }

    handleToggleAutoplayGames(value) {
        this.autoplayOptions.gamesLimit = value;
    }

    handleToggleTurboSpin(value) {
        this.autoplayOptions.turboSpin = value;
        this.data.spinType = value ? "turbo" : "normal";
    }

    handleChangeSpinType(value) {
        this.popup.setQuickSpin(value === "quick");
        this.popup.setTurboSpin(value === "turbo");

    }

    handleToggleSkipScreen(value) {
        this.autoplayOptions.skipScreen = value;
    }

    handleStartAutoplay() {
        this.autoplay.start({ ...this.autoplayOptions });
        this.hud.showStopAutoplayButton();
        this.owner.goTo(GameStates.IDLE);
    }
}
